import React, { useState, useEffect } from 'react';
import { ReactComponent as LineChartIcon } from '../../images/line-chart-up-01.svg';
import { ReactComponent as MarkerChartIcon } from '../../images/bar-line-chart.svg';
import './LineMarkerEditModal.scss';
import LineMarkerSettings from './LineMarkerSettings/LineMarkerSettings';

export interface LineAndMarkerSettings {
  lineType: string;
  lineColor: string;
  lineWeight: number;
  markerType: string;
  markerColor: string;
  markerSize: number;
}

interface LineMarkerEditModalProps {
  onLineMarkerSettingsChange: (settings: LineAndMarkerSettings) => void;
  initialSettings: LineAndMarkerSettings;
  onLineReset: () => void;
  onMarkerReset: () => void;
}

const LineMarkerEditModal: React.FC<LineMarkerEditModalProps> = ({
  onLineMarkerSettingsChange,
  initialSettings,
  onLineReset,
  onMarkerReset,
}) => {
  const [settings, setSettings] = useState(initialSettings);

  useEffect(() => {
    setSettings(initialSettings); // in case modal is reopened
  }, [initialSettings]);

  const handleSettingsChange = (updatedSettings: LineAndMarkerSettings) => {
    setSettings(updatedSettings);
    onLineMarkerSettingsChange(updatedSettings);
  };

  return (
    <main className='line-chart-container'>
      <article className='line-chart-panel'>
        <div className='line-chart-panel-content'>
          <LineMarkerSettings
            title='Line'
            icon={<LineChartIcon />}
            title2='Marker'
            icon2={<MarkerChartIcon />}
            initialSettings={settings}
            onLineAndMarkerChange={handleSettingsChange}
            onLineReset={onLineReset}
            onMarkerReset={onMarkerReset}
          />
        </div>
      </article>
    </main>
  );
};

export default LineMarkerEditModal;
